import { createQueryKeys } from "@lukemorales/query-key-factory";

import MasterApiBase from "./master-api.base";

export default class InflowSourcesApi extends MasterApiBase {
	/**
	 * Creates an inflow source.
	 */
	createInflowSource = function (data) {
		return this.axios.post(`${this.endpoints.inflowSources}`, data);
	};

	/**
	 * Updates an inflow source.
	 */
	updateInflowSource = function (id, data) {
		return this.axios.put(`${this.endpoints.inflowSources}/${id}`, data);
	};

	/**
	 * Deletes an inflow source.
	 */
	deleteInflowSource = function (id) {
		return this.axios.delete(`${this.endpoints.inflowSources}/${id}`);
	};

	/**
	 * Fetches detailed info on an inflow source.
	 */
	getInflowSourceDetails = function (id) {
		return this.axios.get(`${this.endpoints.inflowSources}/${id}`);
	};

	/**
	 * Retrieves all inflow sources.
	 */
	getAllInflowSources = function () {
		return this.axios.get(`${this.endpoints.inflowSources}/list`);
	};

	/**
	 * Retrieves all inflow sources based on the provided parameters.
	 */
	#findAll = function (params) {
		return this.axios.get(this.endpoints.inflowSources, {
			params,
		});
	};

	queryKeys = createQueryKeys("inflowSources", {
		list: (filters) => ({
			queryKey: [{ filters }],
			queryFn: () => this.#findAll(filters),
		}),
		listAll: () => ({
			queryKey: ["all"],
			queryFn: () => this.getAllInflowSources(),
		}),
	});
}
